import React, { Component } from "react";
import { connect } from "react-redux";
import Immutable from "immutable";
import FontAwesome from "react-fontawesome";

import Modal from '@mawesi-sas/mws_react_component_modal';
import Input from '@mawesi-sas/mws_react_component_input';
import ButtonStrip from "../../Layout/components/ButtonStrip";
import BoxButton from "../../Layout/components/BoxButton";

import { showHideModalCancel, cancelarSolicitud } from "../actions";

class ModalCancel extends Component {
  modalContent = () => {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            Esta seguro que desea cancelar esta solicitud?
          </div>
        </div>
      </div>
    );
  };

  

  render() {
    const { modalCancel } = this.props;

    return (
      <Modal
        mostrar={modalCancel.get("show")}
        contenido={this.modalContent()}
        titulo={`Cancelación de la solicitud No. ${modalCancel.getIn(
          "data.id".split(".")
        )}`}
        nombre="modal_cancelar_solicitud"
        onCerrarModal={() => this.props.showHideModalCancel(false)}
        botones={
          <React.Fragment>
            <button
              className="btn btn-sm btn-danger"
              onClick={e => this.props.cancelarSolicitud()}
            >
              Cancelar solicitud
            </button>
          </React.Fragment>
        }
      />
    );
  }
}

const mapStateToProps = (state, onwProps) => {
  return {
    modalCancel: state.solicitud.get("modalCancel")
  };
};

const mapDispatchToProps = {
  showHideModalCancel,
  cancelarSolicitud
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalCancel);
